// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__K1U9o","username":"Navbar_username__P3-OO"};